//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'
import DentBanner from '../../../components/Banners/DentBanners/DentBanner.vue';
import HairBanner from '../../../components/Banners/HairBanners/HairBanner.vue';
import ObesityBanner from '../../../components/Banners/ObesityBanners/ObesityBanner.vue';
import AlignedSmileBanner from '../../../components/Banners/DentBanners/AlignedSmileBanner.vue';
import GeneralDentBanner from '../../../components/Banners/DentBanners/GeneralDentBanner.vue';
import WeightLossSurgeryBanner from '../../../components/Banners/ObesityBanners/WeightLossSurgeryBanner.vue';
import DietTreatmentBanner from '../../../components/Banners/ObesityBanners/DietTreatmentBanner.vue';
import HairRegainBanner from '../../../components/Banners/HairBanners/HairRegainBanner.vue';
import HairTransplantBanner from '../../../components/Banners/HairBanners/HairTransplantBanner.vue';
import GeneralBanner from '../../../components/Banners/GeneralBanners/GeneralBanner.vue';

export default {
  layout: 'blog',
  name: 'index',
  mixins: [SEO, JSONSCHEMA],
  data() {
    return {
      currentPage: 1
    }
  },
  components: {
    DentBanner,
    HairBanner,
    ObesityBanner,
    AlignedSmileBanner,
    GeneralDentBanner,
    WeightLossSurgeryBanner,
    DietTreatmentBanner,
    HairRegainBanner,
    HairTransplantBanner,
    GeneralBanner,
  },
  methods: {
    async fetchCategoryPost(index) {
      if (this.currentPage != index) {
        this.$router.push({ path: this.$route.path, query: { page: `${index}` } })
        const latestpostResponse = await this.$api.fetchCategoryPost(this.$route.params.category, index)
        this.page = latestpostResponse.content
        var element = document.getElementsByClassName('rightside-sidebar')[0];
        window.scrollTo(0, element.offsetTop);
        this.currentPage = index
      }
    },
  },
  mounted() {
    if (this.$route && this.$route.query && this.$route.query.page) {
      this.currentPage = Number(this.$route.query.page)
    }
    else {
      this.currentPage = 1
    }
    this.$router.push({ path: this.$route.path, query: { page: `${this.currentPage}` } })

  },
  asyncData(context) {
    return context.app.$api.fetchCategoryPost(context.params.category, context.query.page ? context.query.page : 1)
      .then(response => {
        return {
          page: response.content
        }
      })
      .catch(e => {
        context.error({ statusCode: 404 })
      })
  },
}
